import {
	ACTIVE_ADD_PEOPLE_MODAL_FOR_PROJECT,
	CLEAR_ANONYMISE_PROFILES,
	CLEAR_IMPORT_LINKEDIN_PROFILE_INFO_FOR_PROJECT,
	CLEAR_SIMILAR_CANDIDATES_RESULTS,
	FLAG_CANDIDATE,
	GET_CANDIDATES_BY_FILTER_DONE,
	GET_CANDIDATES_BY_FILTER_INIT,
	GET_CANDIDATES_DONE,
	GET_CANDIDATES_FAIL,
	GET_CANDIDATES_INIT,
	GET_SIMILAR_CANDIDATES_DONE,
	GET_SIMILAR_CANDIDATES_FAIL,
	GET_SIMILAR_CANDIDATES_INIT,
	GET_SINGLE_CANDIDATE_DONE,
	GET_SINGLE_CANDIDATE_FAIL,
	GET_SINGLE_CANDIDATE_INIT,
	HIDE_CANDIDATE_FROM_TARGET_LIST_DONE,
	IMPORT_LINKEDIN_PROFILE_IN_PROGRESS,
	LOGOUT,
	RESET_FILTERED_CANDIDATES,
	SEARCH_LINKEDIN_PROFILE_IN_PROGRESS_FOR_CURRENT_IMPORT,
	SET_ANONYMISE_PROFILES,
	SET_AP_CANDIDATES_WITH_RECOMMENDED_CANDIDATES,
	SET_CANDIDATES_PAGINATION_INFO,
	SET_IMPORT_LINKEDIN_PROFILE_INFO,
	SET_SIMILAR_CANDIDATES_WITH_PAGINATION,
	TOGGLE_ANONYMISE_PROFILE_TURN_ON,
	UPDATE_AP_CANDIDATE_BY_KEY,
	UPDATE_CANDIDATE_PROFILE_AFTER_REFRESH,
} from "store/mapXActionTypes";
import {TCandidateReducerState} from "store/candidate/candidateReducer.types";
import {AnyAction} from "redux";

export const candidateInitialState: TCandidateReducerState = {
	candidates: [],
	paginationInfo: null,
	currentCandidate: null,
	candidateError: false,
	candidatesError: false,
	candidatesInProgress: false,
	filteredCandidatesInProgress: false,
	candidateProfileInProgress: false,
	similarCandidates: [],
	similarCandidatesPaginationInfo: null,
	similarCandidatesError: false,
	similarCandidatesInProgress: false,
	importLinkedInCandidateInProgress: false,
	importLinkedInProfileInfo: null,

	candidateImportByLinkedInForProject: {}, // used for a project // Structure projectId: Info
	searchCandidateForProject: {}, // projectId: true/false, if a link doesn't exist on a database, we trigger scraping
	activeAddPeopleModalForProject: null, // can be null or id
	anonymisedCandidates: [],
	anonymisedCandidatePhotoCollection: {
		white: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fc3e0319f-4b0a-436a-9d93-627e467d5a9f.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fd2ea762a-13cd-4d05-b93b-f01258b1b75f.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F2b297007-e172-4f72-b1cd-ea45b9439923.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F1d68d8ee-f1fb-4b77-8708-8e7534912ed2.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F767c39e0-97ed-48c2-bf24-4293bf561d6e.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fcbb071ab-be2f-4d3c-a2f6-7c67e310fd11.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fecc28131-c72b-4a84-ab81-4d2f21261fc4.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F601a291f-2a74-40b5-8d86-a3b1d9d8faea.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F45458b16-12e8-4b96-a73b-ef6482d0f057.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fcbb071ab-be2f-4d3c-a2f6-7c67e310fd11.png",
			],
		},
		hispanic: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F7a644cde-97bf-48a4-b2ca-54840c5c96a8.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F641e0c6d-1c91-4dde-be99-19209cc8ad77.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F400b785a-4f3c-4d26-8cff-b2b772f3ccff.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F6eac38f5-d8ff-40be-b964-7fd516e1e6ce.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F1f287576-6d5b-4628-9012-aed15e309de6.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F61f93437-6285-4a38-8f9f-4db8e4b4d300.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F31679b9c-67ac-4d73-bb40-d25c6828930c.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ff6f88966-f963-4e48-9f77-7ee6afc8e96b.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F3f5a3aea-f580-4f78-b6f9-3a6c9d67ff0b.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fbaca49ca-36f3-486f-aa0f-f55428b37d3b.png",
			],
		},
		southAsian: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fded23862-1d08-49cb-a4ff-bb5459db1110.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fb7b5f74c-93f2-43ec-acef-0692b8511aec.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F802a22a8-206b-4185-b3ad-44e185d931e8.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ffaee36d5-aaae-4f54-b567-070da41b57c0.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fa17715c6-9b2a-4c2f-90ba-a3b5722eb639.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F860b4107-b2af-4e77-9464-6116493d6044.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fc1c29fea-fb6d-4e25-8087-33f9a3c95a93.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fc4c96efd-446e-4e3b-bad1-c5fc63e0991c.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F81f341af-dbe7-473d-86cd-2e3a3c924b83.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F2a707b81-9435-4fe1-8910-68ae5f44e1a8.png",
			],
		},
		eastAsian: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fd5b57642-2f8e-4c79-8001-f3041eecf150.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F24975d67-e874-4cf7-b8c8-b07d98d4e806.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ff4b35c1a-f504-46c6-9706-a89aa0ec6ef3.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fd6f384fb-4aee-49a8-a2a1-996378faa653.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F84fb5cc6-1ca2-47da-b796-d814da03f8a9.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ff294c9da-a214-4139-bc1f-37ffe0adfeee.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F66603f3c-a3d8-4964-84cc-0ec5ded3b510.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fb8c2be6e-3e33-4d0b-8e70-e16783ae9562.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ff4431752-30a0-4778-be7e-c1462b7df1a7.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fcdd8927b-013c-41b0-b838-16d0ad8e95a9.png",
			],
		},
		middleEastern: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fedbfa872-cb71-4293-bce5-2ac5048fc17e.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fab5be568-c337-492a-921e-688bb89a2f88.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F17c44d69-9c71-498b-b078-3471020a7675.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F0e96d8df-7a32-4a06-a527-3094139aefbf.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F25534280-0130-4c5f-bb00-0b60f4bd7c6f.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fc391cdc0-72f5-497c-8ddd-cbb7cfd40209.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F621e59f6-08e0-4ea0-a4bd-0cfd42f07d39.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F0d6c23c3-0a06-47a8-8cef-f4408c0bb731.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F4ca1ea2b-e761-48a3-aab0-d51159f34f2e.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fe49ed830-0031-4507-9d56-ac063365b415.png",
			],
		},
		black: {
			male: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fe4a9aaea-43b2-495b-ab44-2f028f1e4f4a.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F9960967a-633f-49d8-a968-f4eb2ad3c228.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F4da7f54a-565d-446d-8ef8-109fddb8b932.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F95128982-e80a-4d60-91f7-99f07738f00c.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Ff9089ffa-98f2-4190-86c4-ee9282b34ebd.png",
			],
			female: [
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fbbdd3887-0325-436a-96b8-fb3fbd530262.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fba66c78b-bd63-4876-b7b6-1651e0383f91.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F8e33eb2f-29f5-495b-ba02-872d85f1084a.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2F8dde3778-ba53-486f-9137-40adf47d5524.png",
				"https://storage.googleapis.com/dall-e-images/lQJUDplcyzUN3i2urggwMsUsA513%2Fb3546e75-9282-4105-a8ec-5404353a38bc.png",
			],
		},
	},
	anonymiseProfileModeTurnedOn: false,
};

const candidateReducer = (state = candidateInitialState, action: AnyAction) => {
	switch (action.type) {
		case GET_CANDIDATES_INIT:
			return {...state, candidatesInProgress: true};
		case GET_CANDIDATES_DONE:
			const candidates = [...action.payload.data];
			const paginationInfo = action.payload.paginationInfo;

			return {
				...state,
				candidatesInProgress: false,
				filteredCandidatesInProgress: false,
				candidates,
				paginationInfo,
			};
		case GET_CANDIDATES_FAIL:
			return {
				...state,
				candidatesInProgress: false,
				filteredCandidatesInProgress: false,
				candidatesError: true,
			};

		case GET_CANDIDATES_BY_FILTER_INIT:
			return {...state, filteredCandidatesInProgress: true};

		case GET_CANDIDATES_BY_FILTER_DONE:
			const filteredCandidates = [...action.payload.data];
			const filteredPaginationInfo = action.payload.paginationInfo;

			return {
				...state,
				candidatesInProgress: false,
				filteredCandidatesInProgress: false,
				candidates: filteredCandidates,
				paginationInfo: filteredPaginationInfo,
			};

		case SET_CANDIDATES_PAGINATION_INFO:
			return {
				...state,
				paginationInfo: action.payload.pagination,
			};

		case HIDE_CANDIDATE_FROM_TARGET_LIST_DONE:
			const candidate = action.payload;

			const updatedData = [...state.candidates].filter((c) => c.id !== candidate.id);

			return {
				...state,
				candidates: updatedData,
				paginationInfo: {
					...state.paginationInfo,
					count: (state.paginationInfo?.count || 1) - 1,
				},
			};

		case GET_SIMILAR_CANDIDATES_INIT:
			return {...state, similarCandidatesInProgress: true};
		case GET_SIMILAR_CANDIDATES_DONE:
			const similarCandidates = [...action.payload];

			return {
				...state,
				similarCandidates,
				similarCandidatesInProgress: false,
			};
		case GET_SIMILAR_CANDIDATES_FAIL:
			return {
				...state,
				similarCandidatesError: true,
			};
		case CLEAR_SIMILAR_CANDIDATES_RESULTS:
			return {
				...state,
				similarCandidates: [],
				similarCandidatesPaginationInfo: null,
			};
		case SET_SIMILAR_CANDIDATES_WITH_PAGINATION:
			const prevSimilarCandidates =
				action.payload.pageNumber > 1 ? state.similarCandidates : [];
			const updatedSimilarCandidates = [...prevSimilarCandidates, ...action.payload.data];

			return {
				...state,
				similarCandidatesInProgress: false,
				similarCandidates: updatedSimilarCandidates,
				similarCandidatesPaginationInfo: {...action.payload.paginationInfo},
			};

		case GET_SINGLE_CANDIDATE_INIT:
			return {...state, candidateProfileInProgress: true};
		case GET_SINGLE_CANDIDATE_DONE:
			return {
				...state,
				currentCandidate: action.payload,
				candidateProfileInProgress: false,
			};
		case FLAG_CANDIDATE:
			return {
				...state,
				currentCandidate: {
					...state.currentCandidate,
					is_data_flagged_wrong: action.payload,
				},
			};
		case GET_SINGLE_CANDIDATE_FAIL:
			return {
				...state,
				candidateError: true,
			};
		case RESET_FILTERED_CANDIDATES:
			return {
				...state,
				candidatesInProgress: false,
				candidates: [],
				paginationInfo: null,
				similarCandidates: [],
				similarCandidatesPaginationInfo: null,
			};

		case IMPORT_LINKEDIN_PROFILE_IN_PROGRESS:
			return {
				...state,
				importLinkedInCandidateInProgress: action.payload,
			};
		case SET_IMPORT_LINKEDIN_PROFILE_INFO:
			return {
				...state,
				importLinkedInProfileInfo: action.payload,
			};

		case SEARCH_LINKEDIN_PROFILE_IN_PROGRESS_FOR_CURRENT_IMPORT:
			return {
				...state,
				searchCandidateForProject: {
					...state.searchCandidateForProject,
					[action.payload.id]: action.payload.data, // sets boolean value for project by id
				},
			};

		case CLEAR_IMPORT_LINKEDIN_PROFILE_INFO_FOR_PROJECT:
			const data = {...state.candidateImportByLinkedInForProject};
			const dataProgressInfo = {...state.searchCandidateForProject};
			const id = action.payload;

			if (id in data) {
				delete data[id];
			}

			if (id in dataProgressInfo) {
				delete dataProgressInfo[id];
			}

			return {
				...state,
				candidateImportByLinkedInForProject: {...data},
				searchCandidateForProject: {...dataProgressInfo},
			};

		case UPDATE_CANDIDATE_PROFILE_AFTER_REFRESH:
			return {
				...state,
				currentCandidate:
					state.currentCandidate && state.currentCandidate?.id === action.payload?.id
						? {...action.payload}
						: state.currentCandidate,
				candidates: [
					...state.candidates.map((c) => {
						if (c.id === action.payload.id) {
							return action.payload;
						} else return c;
					}),
				],
			};

		case SET_AP_CANDIDATES_WITH_RECOMMENDED_CANDIDATES:
			return {
				...state,
				currentCandidate:
					state.currentCandidate?.id === action.payload?.id
						? {
								...state.currentCandidate,
								is_recommended: action.payload.is_recommended,
						  }
						: state.currentCandidate,
			};

		case UPDATE_AP_CANDIDATE_BY_KEY:
			return {
				...state,
				currentCandidate:
					state.currentCandidate?.id === action.payload?.id
						? {
								...state.currentCandidate,
								[action.payload.key]: action.payload.value,
						  }
						: state.currentCandidate,
			};

		case ACTIVE_ADD_PEOPLE_MODAL_FOR_PROJECT:
			return {
				...state,
				activeAddPeopleModalForProject: action.payload,
			};
		case TOGGLE_ANONYMISE_PROFILE_TURN_ON:
			return {
				...state,
				anonymiseProfileModeTurnedOn: action.payload,
			};
		case SET_ANONYMISE_PROFILES:
			return {
				...state,
				anonymisedCandidates: action.payload,
			};
		case CLEAR_ANONYMISE_PROFILES:
			return {
				...state,
				anonymisedCandidates: [],
			};
		case LOGOUT:
			return {
				...state,
				...candidateInitialState,
			};
		default:
			return state;
	}
};

export default candidateReducer;
